import type { ReactNode } from 'react'

/**
 * チェックボックスの四角（Figma: form-field Type=checkbox）。
 * 子に className="peer sr-only" の input を渡すと、checked で黒地＋白チェックになる。
 * エラー時の枠は globals.css の .error_input が data-checkbox-box を見て付ける。
 */
export const CheckboxBox = ({ children }: { children: ReactNode }) => {
  return (
    <span className="relative flex size-5 shrink-0">
      {children}
      <span
        data-checkbox-box
        className="size-5 rounded-sm border border-line bg-surface transition-colors peer-checked:border-line-inverse peer-checked:bg-surface-inverse peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-line-inverse"
      />
      <span
        aria-hidden
        className="icon icon-check pointer-events-none absolute inset-0.5 size-4 text-ink-inverse opacity-0 peer-checked:opacity-100"
      />
    </span>
  )
}
